import FormField from "../form-field";
import ServiceLocator from "../../../../global/service-locator";
import TelInput from "../components/tel-input";

export default class TelField extends FormField {
    constructor(props) {
        super(props);

        this.modalService = ServiceLocator.instance.modalService;
    }

    _beforeInit() {
        this.loading = true;

        this._checkProps();
        this._initElements();
        this.telInput = new TelInput({
            $root: this.$input,
            subscriptions: [
                {
                    event: 'afterInit',
                    callback: () => {
                        this.finishLoading();
                    }
                },
                {
                    event: 'valueChange',
                    callback: this._handleValueChange.bind(this)
                },
                {
                    event: 'blur',
                    callback: this._handleBlur.bind(this)
                },
                {
                    event: 'validationStatusChange',
                    callback: this._handleValidationStatusChange.bind(this)
                }
            ]
        });
    }

    _afterInit() {
        this._refresh();
    }

    _handleValueChange(value) {
        this.controller.setValue(value, { validate: false });
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _handleBlur() {
        this._setStatus(this.controller.valid ? 'valid' : 'invalid');
    }

    _handleValidationStatusChange(valid) {
        this.controller.validate(valid);
    }

    _refresh() {
        this.telInput.setValue(this.controller.getValue() || '');
    }

}